(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec536"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec536"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $685c209dad04ed5d$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("bu0dN"), JSON.parse('["bu0dN","index.32b9c8af.js","740Fj","star-outline.7de9302b.svg","lUxGO","star-filled.fe4dfe0d.svg","iUKVJ","318bb7a02ee3d_001.1c06402a.webp","a5dX5","318bb7a02ee3d_002.3db3000d.webp","4wUHz","318bb7a02ee3d_003.fc3f3802.webp","gdRy1","440cb845c72e1_001.bb809d1d.webp","d3U9t","440cb845c72e1_002.93f5cdff.webp","821I3","440cb845c72e1_003.ac7e525f.webp","82k63","57f82f074d9af_001.38b64493.webp","4j5si","57f82f074d9af_002.e6561cde.webp","4vBLk","e1362a1c72141_001.1501f7a0.webp","hfVpB","e1362a1c72141_002.2a168a33.webp","64BpH","b402c3a2a501a_001.5d97aeb6.webp","ctMkk","51453ff801875_001.687e0296.webp","4svOv","51453ff801875_002.d81349e8.webp","kWw0J","ec23f5702ae68_001.68afa0e7.webp","1hi9J","06f1a8efc291c_001.329671b7.webp","aQchM","be1d80cfd8008_001.6f0cb91e.webp","339k5","be1d80cfd8008_002.e58828d8.webp","d9j4V","be1d80cfd8008_003.3bfa91b2.webp","f0N1T","f35796a06df51_001.9fb3d59c.webp","4uo8x","f35796a06df51_002.28d182a2.webp","ikx0r","318bb7a02ee3d_001.ef4c2818.png","bjpON","440cb845c72e1_001.1cf4283c.png","BPfgG","440cb845c72e1_002.243995ec.png","1vljG","440cb845c72e1_003.3e5d7e1d.png","fQyNg","57f82f074d9af_001.81e39e2d.png","drDmJ","57f82f074d9af_002.169d640a.png","b5pqU","e1362a1c72141_001.5f4e2c88.png","9yltf","e1362a1c72141_002.e89e6494.png","d4sT9","b402c3a2a501a_001.5a2237bd.png","7QnxL","51453ff801875_001.acfb695b.png","3l1AG","51453ff801875_002.c2a94a25.png","7Bgxp","ec23f5702ae68_001.0725a639.png","lmtJt","06f1a8efc291c_001.2a7cc0b2.png","dFtZc","be1d80cfd8008_001.37799ac6.png","ga1Qi","be1d80cfd8008_002.4c813491.png","7XH9X","be1d80cfd8008_003.2bbef90a.png","ksJRY","f35796a06df51_001.8cf6bdb3.png","fU4wA","f35796a06df51_002.d0f8105c.png"]'));

var $29d54733ded3a77f$exports = {};

$29d54733ded3a77f$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "star-outline.7de9302b.svg";


var $b8bf7c4d90a714ff$exports = {};

$b8bf7c4d90a714ff$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "star-filled.fe4dfe0d.svg";


var $8af8d933cfadca83$exports = {};

$8af8d933cfadca83$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "318bb7a02ee3d_001.1c06402a.webp";


var $779955ef8398c99d$exports = {};

$779955ef8398c99d$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "318bb7a02ee3d_002.3db3000d.webp";


var $a484c20d64e3c35a$exports = {};

$a484c20d64e3c35a$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "318bb7a02ee3d_003.fc3f3802.webp";


var $1f8498e39ff9fd45$exports = {};

$1f8498e39ff9fd45$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_001.bb809d1d.webp";


var $42fe72eb1b9125e0$exports = {};

$42fe72eb1b9125e0$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_002.93f5cdff.webp";


var $99b762d6a89f0cff$exports = {};

$99b762d6a89f0cff$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_003.ac7e525f.webp";


var $5e5477238413d78a$exports = {};

$5e5477238413d78a$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "57f82f074d9af_001.38b64493.webp";


var $3b7853e941e5215a$exports = {};

$3b7853e941e5215a$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "57f82f074d9af_002.e6561cde.webp";


var $1c415793b20d6a66$exports = {};

$1c415793b20d6a66$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "e1362a1c72141_001.1501f7a0.webp";


var $f582a52f96bb8a70$exports = {};

$f582a52f96bb8a70$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "e1362a1c72141_002.2a168a33.webp";


var $dab7f78170e28b86$exports = {};

$dab7f78170e28b86$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "b402c3a2a501a_001.5d97aeb6.webp";


var $5260620392f5da37$exports = {};

$5260620392f5da37$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "51453ff801875_001.687e0296.webp";


var $c5d13baba055d535$exports = {};

$c5d13baba055d535$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "51453ff801875_002.d81349e8.webp";


var $7e1a1262c439007f$exports = {};

$7e1a1262c439007f$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "ec23f5702ae68_001.68afa0e7.webp";


var $1a6436be3841d4b7$exports = {};

$1a6436be3841d4b7$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "06f1a8efc291c_001.329671b7.webp";


var $615311e24041be57$exports = {};

$615311e24041be57$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_001.6f0cb91e.webp";


var $6b36cc414aac4593$exports = {};

$6b36cc414aac4593$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_002.e58828d8.webp";


var $7ae99b40cb5653ad$exports = {};

$7ae99b40cb5653ad$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_003.3bfa91b2.webp";


var $67c64d001d9b9115$exports = {};

$67c64d001d9b9115$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "f35796a06df51_001.9fb3d59c.webp";


var $f30fe2783cb7f0bb$exports = {};

$f30fe2783cb7f0bb$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "f35796a06df51_002.28d182a2.webp";


var $e7a09d8d6c23b4bb$exports = {};

$e7a09d8d6c23b4bb$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "318bb7a02ee3d_001.ef4c2818.png";


var $fa541bb26b0cf1ab$exports = {};

$fa541bb26b0cf1ab$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_001.1cf4283c.png";


var $605085fb7f495f92$exports = {};

$605085fb7f495f92$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_002.243995ec.png";


var $060a4b85808d3bdc$exports = {};

$060a4b85808d3bdc$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "440cb845c72e1_003.3e5d7e1d.png";


var $a1fec01ac89e8595$exports = {};

$a1fec01ac89e8595$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "57f82f074d9af_001.81e39e2d.png";


var $4470488b96d4d44d$exports = {};

$4470488b96d4d44d$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "57f82f074d9af_002.169d640a.png";


var $dab0d11774ee30fc$exports = {};

$dab0d11774ee30fc$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "e1362a1c72141_001.5f4e2c88.png";


var $43d9bbcb4fceb8fb$exports = {};

$43d9bbcb4fceb8fb$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "e1362a1c72141_002.e89e6494.png";


var $6550863ffd7a951a$exports = {};

$6550863ffd7a951a$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "b402c3a2a501a_001.5a2237bd.png";


var $a425ad2e8435fb68$exports = {};

$a425ad2e8435fb68$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "51453ff801875_001.acfb695b.png";


var $8cdacbc6cb535531$exports = {};

$8cdacbc6cb535531$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "51453ff801875_002.c2a94a25.png";


var $f352484b55bcf7d7$exports = {};

$f352484b55bcf7d7$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "ec23f5702ae68_001.0725a639.png";


var $df6a0d023e640ef0$exports = {};

$df6a0d023e640ef0$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "06f1a8efc291c_001.2a7cc0b2.png";


var $0f751d9d5ceb67fc$exports = {};

$0f751d9d5ceb67fc$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_001.37799ac6.png";


var $30663ba0b730bf92$exports = {};

$30663ba0b730bf92$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_002.4c813491.png";


var $ae5a6940a1f35742$exports = {};

$ae5a6940a1f35742$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "be1d80cfd8008_003.2bbef90a.png";


var $a1db3306e61160f9$exports = {};

$a1db3306e61160f9$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "f35796a06df51_001.8cf6bdb3.png";


var $b49310e6aad53016$exports = {};

$b49310e6aad53016$exports = (parcelRequire("aNJCr")).getBundleURL("bu0dN") + "f35796a06df51_002.d0f8105c.png";


const $02eab58f886281d5$export$5e8d0e068d84aae1 = [
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 100g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($e7a09d8d6c23b4bb$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($8af8d933cfadca83$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($e7a09d8d6c23b4bb$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($779955ef8398c99d$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($e7a09d8d6c23b4bb$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($a484c20d64e3c35a$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: "4,200.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 50g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($fa541bb26b0cf1ab$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($1f8498e39ff9fd45$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($605085fb7f495f92$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($42fe72eb1b9125e0$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($060a4b85808d3bdc$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($99b762d6a89f0cff$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: "2,100.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 30g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($a1fec01ac89e8595$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($5e5477238413d78a$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($4470488b96d4d44d$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($3b7853e941e5215a$exports))),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: "1,300.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tho\u0302 100g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($dab0d11774ee30fc$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($1c415793b20d6a66$exports))),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket next to gold flowers"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($43d9bbcb4fceb8fb$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($f582a52f96bb8a70$exports))),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket next to gold flowers"
            }
        ],
        price: "2,600.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tho\u0302 50g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($6550863ffd7a951a$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($dab7f78170e28b86$exports))),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket "
            }
        ],
        price: "1,300.000 ",
        rating: 5
    },
    {
        title: "Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng 100g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($a425ad2e8435fb68$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($5260620392f5da37$exports))),
                desc: "Picture of Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng laying in a glass bowl"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($8cdacbc6cb535531$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($c5d13baba055d535$exports))),
                desc: "Zoomed in picture of Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng"
            }
        ],
        price: "3,200.000 ",
        rating: 5
    },
    {
        title: "Cha\u0302n Ye\u0302\u0301n Tho\u0302 100g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($f352484b55bcf7d7$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($7e1a1262c439007f$exports))),
                desc: "Picture of Cha\u0302n Ye\u0302\u0301n Tho\u0302 placed in a gold container"
            }
        ],
        price: "2,200.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 100g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($df6a0d023e640ef0$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($1a6436be3841d4b7$exports))),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in a basket next to a card with pink flowers "
            }
        ],
        price: "3,600.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 50g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($0f751d9d5ceb67fc$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($615311e24041be57$exports))),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in bowl on top of white paper"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($30663ba0b730bf92$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($6b36cc414aac4593$exports))),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in bowl on top of white paper"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($ae5a6940a1f35742$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($7ae99b40cb5653ad$exports))),
                desc: "Zoomed in picured of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying on a blue mat"
            }
        ],
        price: "1,800.000 ",
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 30g",
        images: [
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($a1db3306e61160f9$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($67c64d001d9b9115$exports))),
                desc: "Picure of Ye\u0302\u0301n Tinh Che\u0302\u0301  laying in a clear plastic bowl"
            },
            {
                png: (0, (/*@__PURE__*/$parcel$interopDefault($b49310e6aad53016$exports))),
                webp: (0, (/*@__PURE__*/$parcel$interopDefault($f30fe2783cb7f0bb$exports))),
                desc: "Picure of Ye\u0302\u0301n Tinh Che\u0302\u0301  laying in a clear plastic bowl next to a red card"
            }
        ],
        price: "1,100.000 ",
        rating: 5
    }
];


///////////////////////////////////////////////////////////
// Nav global references
const $66b821ea461d9f2a$var$productHeadingEl = document.querySelector(".product-heading");
const $66b821ea461d9f2a$var$productSectionEL = document.querySelector(".section-product");
const $66b821ea461d9f2a$var$navMission = "./index.html#mission";
const $66b821ea461d9f2a$var$navWhy = "./index.html#why";
const $66b821ea461d9f2a$var$navProducts = "./index.html#products";
const $66b821ea461d9f2a$var$navTestimonial = "./index.html#testimonial-section";
const $66b821ea461d9f2a$var$navContact = "./index.html#contact";
const $66b821ea461d9f2a$var$navHome = "./index.html#header";
// Setting href for all pages
const $66b821ea461d9f2a$var$missionNodes = Array.from(document.querySelectorAll(".mission-link"));
$66b821ea461d9f2a$var$missionNodes.forEach((el)=>el.href = $66b821ea461d9f2a$var$navMission);
document.querySelector(".why-link").href = $66b821ea461d9f2a$var$navWhy;
document.querySelector(".products-link").href = $66b821ea461d9f2a$var$navProducts;
document.querySelector(".testimonial-link").href = $66b821ea461d9f2a$var$navTestimonial;
document.querySelector(".contact-link").href = $66b821ea461d9f2a$var$navContact;
document.querySelector(".footer-logo").href = $66b821ea461d9f2a$var$navHome;
document.querySelector(".logo-container").href = $66b821ea461d9f2a$var$navHome;
// Search bar defaults
document.getElementById("y-search").placeholder = "B\u1EA1n mu\u1ED1n t\xecm g\xec ...";
document.getElementById("y-search-mobile").placeholder = "B\u1EA1n mu\u1ED1n t\xecm g\xec ...";
const $66b821ea461d9f2a$var$updateProductView = ()=>{
    const previousProducts = Array.from(document.querySelectorAll(".product"));
    const productsContainer = document.querySelector(".product-container");
    $66b821ea461d9f2a$var$productHeadingEl.textContent = "Search Results";
    previousProducts.forEach((el)=>{
        productsContainer.removeChild(el);
    });
};
document.getElementById("search-form").addEventListener("submit", function(e) {
    e.preventDefault();
    $66b821ea461d9f2a$var$updateProductView();
    if (!document.getElementById("y-search").value) return;
    document.getElementById("search-icon").style.display = "none";
});
document.getElementById("search-form-mobile").addEventListener("submit", function(e) {
    e.preventDefault();
});
document.getElementById("y-search").addEventListener("search", function(e) {
    if (e.target.value.length > 2) {
        const searchResults = $66b821ea461d9f2a$var$products.loadSearch(e.target.value);
        if (!searchResults) $66b821ea461d9f2a$var$productHeadingEl.textContent = "Search Results - Nothing Found";
    }
    // Clearing search results
    if (e.target.value === "") {
        document.getElementById("search-icon").style.display = "inline-block";
        $66b821ea461d9f2a$var$updateProductView();
        $66b821ea461d9f2a$var$products.loadProducts();
        $66b821ea461d9f2a$var$productHeadingEl.textContent = "T\u1ED5 Y\u1EBFn";
    }
    $66b821ea461d9f2a$var$productSectionEL.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    });
});
document.getElementById("y-search-mobile").addEventListener("search", function(e) {
    $66b821ea461d9f2a$var$updateProductView();
    if (e.target.value.length > 2) {
        const searchResults = $66b821ea461d9f2a$var$products.loadSearch(e.target.value);
        document.querySelector(".product-heading").textContent = "Search Results";
        if (!searchResults) $66b821ea461d9f2a$var$productHeadingEl.textContent = "Search Results - Nothing Found";
    }
    // Clearing search results
    if (e.target.value === "") {
        $66b821ea461d9f2a$var$updateProductView();
        $66b821ea461d9f2a$var$products.loadProducts();
        $66b821ea461d9f2a$var$productHeadingEl.textContent = "T\u1ED5 Y\u1EBFn";
    }
    $66b821ea461d9f2a$var$productSectionEL.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    });
    $66b821ea461d9f2a$var$headerEl.classList.toggle("nav-open");
});
///////////////////////////////////////////////////////////
// Products
class $66b821ea461d9f2a$var$ProductImages {
    constructor(imgPng, imgWebp, imgdescription){
        this.imageSet = [
            imgWebp,
            imgPng
        ]; //[webp, png]
        this.imgdescription = imgdescription;
    }
}
class $66b821ea461d9f2a$var$Product {
    id = Math.random().toString(16).split(".").at(-1);
    constructor(ProductImages, title, rating, price){
        this.images = ProductImages;
        this.title = title;
        this.rating = rating;
        this.price = price;
    }
    _stars(rating) {
        const filledStarsAmt = Math.round(rating);
        const filledStarsTemplate = `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($b8bf7c4d90a714ff$exports)))}" class="product-icon-star" alt="Solid star icon"/>`;
        const emptyStarsTemplate = `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($29d54733ded3a77f$exports)))}" class="product-icon-star" alt="Star icon outline"/>`;
        const elFilledStars = filledStarsTemplate.repeat(filledStarsAmt);
        const elOutlineStar = emptyStarsTemplate.repeat(5 - filledStarsAmt);
        return {
            elFilledStars: elFilledStars,
            elOutlineStar: elOutlineStar
        };
    }
    _pictureMarkup(png, webp, imgDesc) {
        const markup = `
    <picture class="product-picture-${this.id}">
    <source srcset="${webp}" type="image/webp"/>
    <source srcset="${png}" type="image/png"/>
    <img
      src="${png}"
      class="product-img"
      alt="${imgDesc}"/>
    </picture>
    `;
        return markup;
    }
    createMarkup() {
        const { elFilledStars: elFilledStars, elOutlineStar: elOutlineStar } = this._stars(this.rating);
        const productImgArr = this.images.map((el)=>({
                images: el.imageSet,
                alt: el.imgdescription
            }));
        const picturesEl = productImgArr.map((el)=>this._pictureMarkup(el.images[1], el.images[0], el.alt)).join("");
        let markup = `
    <div class="product">
    <div class="${this.id}Images product-img-container"> `;
        markup += picturesEl;
        markup += `
    </div>
    <div class="product-content">
      <p class="product-title">${this.title}</p>
      <ul class="product-attributes">
        <li class="product-attribute">
          ${elFilledStars}
          ${elOutlineStar}
        </li>
        <li class="product-attribute">
          <span class="product-description">${this.price}\u{20AB}</span>
        </li>
      </ul>
    </div>`;
        return markup;
    }
}
class $66b821ea461d9f2a$var$Products {
    constructor(products){
        this.products = products;
    }
    loadProducts() {
        this.products.forEach((p)=>{
            $66b821ea461d9f2a$var$productContainer.insertAdjacentHTML("beforeend", p.createMarkup());
        });
    }
    _search(searchStr) {
        const words = searchStr.split(" ").filter((w)=>w.length > 2);
        const filterEl = this.products.map(function(el) {
            const titleArray = el.title.split(" ").map((el)=>el.toLowerCase());
            return words.every((val)=>titleArray.includes(val.toLowerCase())) ? el : null;
        });
        return filterEl.filter((val)=>val !== null);
    }
    loadSearch(searchStr) {
        const queryItems = this._search(searchStr);
        if (queryItems.length > 0) {
            queryItems.forEach((p)=>{
                $66b821ea461d9f2a$var$productContainer.insertAdjacentHTML("beforeend", p.createMarkup());
            });
            return true;
        }
        if (!queryItems) return null;
    }
}
const $66b821ea461d9f2a$var$productContainer = document.querySelector(".product-container");
const $66b821ea461d9f2a$var$productItems = [];
if ($66b821ea461d9f2a$var$productContainer) (0, $02eab58f886281d5$export$5e8d0e068d84aae1).forEach((prod)=>{
    const imgCnt = prod.images.length;
    const productImagesArr = [];
    for(let i = 0; i < imgCnt; i++)productImagesArr.push(new $66b821ea461d9f2a$var$ProductImages(prod.images[i].png, prod.images[i].webp, prod.images[i].desc));
    const productItem = new $66b821ea461d9f2a$var$Product(productImagesArr, prod.title, prod.rating, prod.price);
    $66b821ea461d9f2a$var$productItems.push(productItem);
});
const $66b821ea461d9f2a$var$products = new $66b821ea461d9f2a$var$Products($66b821ea461d9f2a$var$productItems);
$66b821ea461d9f2a$var$products.loadProducts();
// rotate product images
const $66b821ea461d9f2a$var$productSection = document.querySelector(".product-container");
const $66b821ea461d9f2a$var$intervalIds = [];
if ($66b821ea461d9f2a$var$productSection) {
    const productObserver = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === true) // Insert rotating func
        $66b821ea461d9f2a$var$productItems.forEach((item)=>{
            const delay = Math.trunc(Math.random() * 1000 + 4000);
            $66b821ea461d9f2a$var$rotateProductImages(item.id, delay);
        });
        if (ent.isIntersecting === false) {
            $66b821ea461d9f2a$var$intervalIds.forEach((id)=>clearInterval(id));
            $66b821ea461d9f2a$var$intervalIds.splice(0);
        }
    }, {
        root: null,
        threshold: 0,
        rootMargin: "-80px"
    });
    productObserver.observe($66b821ea461d9f2a$var$productSection);
}
const $66b821ea461d9f2a$var$rotateProductImages = function(productId, interval) {
    const pictures = document.querySelectorAll(`.product-picture-${productId}`);
    let currentIndex = 0;
    function showNextImage() {
        pictures[currentIndex].classList.remove("active");
        pictures[currentIndex].style.opacity = "0";
        currentIndex = (currentIndex + 1) % pictures.length;
        pictures[currentIndex].classList.add("active");
        pictures[currentIndex].style.opacity = "1";
    }
    function startImageTransition(interval) {
        pictures[currentIndex].classList.add("active");
        const intervalId = setInterval(showNextImage, interval);
        $66b821ea461d9f2a$var$intervalIds.push(intervalId);
    }
    startImageTransition(interval);
};
///////////////////////////////////////////////////////////
// Set current year
const $66b821ea461d9f2a$var$yearEl = document.querySelector(".year");
const $66b821ea461d9f2a$var$currentYear = new Date().getFullYear();
$66b821ea461d9f2a$var$yearEl.textContent = $66b821ea461d9f2a$var$currentYear;
///////////////////////////////////////////////////////////
// Make mobile navigation work
const $66b821ea461d9f2a$var$btnNavEl = document.querySelector(".btn-mobile-nav");
const $66b821ea461d9f2a$var$headerEl = document.querySelector(".header");
$66b821ea461d9f2a$var$btnNavEl.addEventListener("click", function() {
    $66b821ea461d9f2a$var$headerEl.classList.toggle("nav-open");
});
const $66b821ea461d9f2a$var$navLinks = Array.from(document.querySelectorAll(".main-nav-link"));
$66b821ea461d9f2a$var$navLinks.forEach((link)=>{
    link.addEventListener("click", function(e) {
        $66b821ea461d9f2a$var$headerEl.classList.toggle("nav-open");
    });
});
///////////////////////////////////////////////////////////
// Smooth scrolling animation
const $66b821ea461d9f2a$var$allLinks = document.querySelectorAll("a:link");
$66b821ea461d9f2a$var$allLinks.forEach(function(link) {
    link.addEventListener("click", function(e) {
        const href = link.getAttribute("href");
        if (!href.startsWith("#")) return;
        e.preventDefault();
        // Scroll back to top
        if (href === "#") window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Scroll to other links
        if (href !== "#" && href.startsWith("#")) {
            const sectionEl = document.querySelector(href);
            sectionEl.scrollIntoView({
                behavior: "smooth"
            });
        }
        // Close mobile naviagtion
        if (link.classList.contains("main-nav-link")) $66b821ea461d9f2a$var$headerEl.classList.toggle("nav-open");
    });
});
///////////////////////////////////////////////////////////
// Sticky navigation
const $66b821ea461d9f2a$var$sectionHeroEl = document.querySelector(".section-hero");
if ($66b821ea461d9f2a$var$sectionHeroEl) {
    const obs = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) document.body.classList.add("sticky");
        if (ent.isIntersecting === true) document.body.classList.remove("sticky");
    }, {
        root: null,
        threshold: 0,
        rootMargin: "-80px"
    });
    obs.observe($66b821ea461d9f2a$var$sectionHeroEl);
}
///////////////////////////////////////////////////////////
// Shrink contacts widget in Testimonials section
const $66b821ea461d9f2a$var$sectionTestimonialEl = document.querySelector(".section-testimonials");
const $66b821ea461d9f2a$var$widgetContainer = document.querySelector(".widget-container");
if ($66b821ea461d9f2a$var$widgetContainer) {
    const observer = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) $66b821ea461d9f2a$var$widgetContainer.classList.remove("widget-collapse");
        if (ent.isIntersecting === true) $66b821ea461d9f2a$var$widgetContainer.classList.add("widget-collapse");
    }, {
        root: null,
        threshold: 0,
        rootMargin: "-80px"
    });
    observer.observe($66b821ea461d9f2a$var$sectionTestimonialEl);
}
///////////////////////////////////////////////////////////
// Hide contacts widget on footer section
const $66b821ea461d9f2a$var$sectionFooterEl = document.querySelector(".footer");
if ($66b821ea461d9f2a$var$widgetContainer) {
    const observerFooter = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) $66b821ea461d9f2a$var$widgetContainer.classList.remove("widgets-container-hide");
        if (ent.isIntersecting === true) $66b821ea461d9f2a$var$widgetContainer.classList.add("widgets-container-hide");
    }, {
        root: null,
        threshold: 0,
        rootMargin: "-100px"
    });
    observerFooter.observe($66b821ea461d9f2a$var$sectionFooterEl);
}
///////////////////////////////////////////////////////////
// Fixing flexbox gap property missing in some Safari versions
function $66b821ea461d9f2a$var$checkFlexGap() {
    const flex = document.createElement("div");
    flex.style.display = "flex";
    flex.style.flexDirection = "column";
    flex.style.rowGap = "1px";
    flex.appendChild(document.createElement("div"));
    flex.appendChild(document.createElement("div"));
    document.body.appendChild(flex);
    const isSupported = flex.scrollHeight === 1;
    flex.parentNode.removeChild(flex);
    if (!isSupported) document.body.classList.add("no-flexbox-gap");
}
$66b821ea461d9f2a$var$checkFlexGap();

})();
//# sourceMappingURL=index.32b9c8af.js.map
